/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js'



import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'



import '@quasar/extras/animate/slideInLeft.css'

import '@quasar/extras/animate/slideInRight.css'

import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'


// We add Quasar addons, if they were requested
import 'quasar/src/css/flex-addon.sass'



import 'src/css/app.scss'

import 'src/css/page.scss'

import 'src/css/form.scss'

import 'src/css/backend.scss'


import Vue from 'vue'
import createApp from './app.js'




import qboot_Bootutility from 'boot/utility'

import qboot_Booti18n from 'boot/i18n'

import qboot_Bootaxiosbase from 'boot/axios-base'

import qboot_Bootaxios from 'boot/axios'

import qboot_Bootaxiosmes from 'boot/axios-mes'

import qboot_Bootaxiosassembly from 'boot/axios-assembly'

import qboot_Bootaxiosfile from 'boot/axios-file'

import qboot_BootveeValidation from 'boot/veeValidation'

import qboot_Bootstore from 'boot/store'

import qboot_BootauthMiddleware from 'boot/authMiddleware'

import qboot_Bootdirective from 'boot/directive'

import qboot_Bootckeditor from 'boot/ckeditor'

import qboot_Bootechart from 'boot/echart'







Vue.config.devtools = true
Vue.config.productionTip = false






const publicPath = `/`


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootutility,qboot_Booti18n,qboot_Bootaxiosbase,qboot_Bootaxios,qboot_Bootaxiosmes,qboot_Bootaxiosassembly,qboot_Bootaxiosfile,qboot_BootveeValidation,qboot_Bootstore,qboot_BootauthMiddleware,qboot_Bootdirective,qboot_Bootckeditor,qboot_Bootechart]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
